export function transformAlgoliaResults(results) {
  const hits = results?.hits || [];

  const suggestions = [
    ...new Set(
      hits.flatMap((e) =>
        e?.suggest
          ?.map((word) => word.replace(/,|،/g, ""))
          .filter(
            (s) => s.length > 2 && !/[a-zA-Z].*\d|\d.*[a-zA-Z]|[-/".\d]/.test(s)
          )
      )
    ),
  ].slice(0, 15);

  const banners =
    results?.renderingContent?.widgets?.banners?.map((banner) => ({
      url: banner?.link?.url || "/",
      image_src: banner?.image?.urls[0]?.url || "",
      name: banner?.image?.title,
    })) || [];

  return {
    products: hits,
    suggestions,
    numberOfPages: results?.nbPages || 0,
    numberOfHits: results?.nbHits || 0,
    queryId: results?.queryID || "",
    banners,
  };
}
